/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react'
import styled from 'styled-components'
import {Box, Text, AtlasLozenge, themeGet} from '../..'
import {AkChevronRightIcon, AkArrowRightIcon} from '@fuegokit/fuegoicons-react'
import {STATUSES, RuleTransitionProps} from './types'

/** Describes a transition */
const RuleTransition = ({fromStatus, targetStatus, testId, ...props}: RuleTransitionProps) => {
  const fromLozengeTestId = `${testId}-from-lozenge`
  const toLozengeTestId = `${testId}-to-lozenge`
  const wrapperTestId = `${testId}-wrapper`

  return (
    <Wrapper data-testid={testId ? wrapperTestId : 'undefined'} {...props}>
      <Box>
        <AtlasLozenge appearance={fromStatus} testId={testId ? fromLozengeTestId : 'undefined'}>
          {STATUSES[fromStatus!]}
        </AtlasLozenge>
      </Box>

      <Box sx={{color: 'icon.default'}}>
        <AkArrowRightIcon />
      </Box>

      <Box>
        <AtlasLozenge appearance={targetStatus} testId={testId ? toLozengeTestId : 'undefined'}>
          {STATUSES[targetStatus!]}
        </AtlasLozenge>
      </Box>
    </Wrapper>
  )
}

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.2')};
`

export default RuleTransition
